<template>
  <div class="page">
    <PageHeader
      :to="{ name: 'member-show' }"
    ><div slot="middle">{{ member.fullName }}</div></PageHeader>
    <div class="content pa-8">

      <div class="half-box">
        <v-text-field
          :label="$t('First name')"
          outlined
          v-model="form.firstName"
          class="col-6"
        ></v-text-field>

        <v-text-field
          :label="$t('Last name')"
          outlined
          v-model="form.lastName"
          class="col-6"
        ></v-text-field>

      </div>

      <div class="half-box d-flex justify-end">
        <v-btn
          style="color: #fff !important"
          color="primary"
          @click="updateUser"
        >{{ $t('Save changes') }}</v-btn>
      </div>

    </div>
  </div>
</template>

<script>
import PageHeader from '@/globals/components/PageHeader.vue';

export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
      },
    };
  },
  computed: {
    member() {
      return this.$Member.find(this.$route.params.userId);
    },
  },
  mounted() {
    this.$Member.api().fetchByGroupName(this.$store.state.selectedGroup).then(() => {
      this.resetForm();
    });
  },
  methods: {
    resetForm() {
      this.form.firstName = this.member.firstName;
      this.form.lastName = this.member.lastName;
    },
    updateUser() {
      this.$Member.api().update(this.$route.params.userId, this.form).then(() => {
        this.$toast(this.$t('Changes saved'), { type: 'success' });
        this.$router.push({ name: 'member-show', params: { userId: this.$route.params.userId } });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .content {
    flex: 1;
    background-color: #fff;
    display: flex;
  }

  .half-box {
    width: 50%;
  }
</style>
